function OwnerHeader() {
  return (
    <div className="flex flex-row items-center justify-center">
      <span className="text-sm">List Owner</span>
    </div>
  );
}

export default OwnerHeader;
